import React, { PureComponent } from 'react';

import Html from 'components/Html';
import { ListCard } from 'components/listCard';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import emptyStateImage from '../../../assets/campaigns-empty-state.svg';

import './EmptyState.scss';

@translate()
class EmptyState extends PureComponent {
  static propTypes = {
    t: PropTypes.func
  };

  constructor(props) {
    super(props);

    const { t } = props;

    this.plusAccessCard = {
      title: t('campaign.list.empty_state.learn.plus.title'),
      iconName: 'folders',
      list: [
        {
          id: 'plus_content_section',
          description: t(
            'campaign.list.empty_state.learn.plus.steps.content_section'
          )
        },
        {
          id: 'plus_add_tab',
          description: t('campaign.list.empty_state.learn.plus.steps.add_tab')
        },
        {
          id: 'plus_paid_module',
          description: t(
            'campaign.list.empty_state.learn.plus.steps.paid_module'
          )
        }
      ]
    };

    this.productCard = {
      title: t('campaign.list.empty_state.learn.product.title'),
      iconName: 'box',
      list: [
        {
          id: 'product_content_section',
          description: t(
            'campaign.list.empty_state.learn.product.steps.content_section'
          )
        },
        {
          id: 'product_ads',
          description: t('campaign.list.empty_state.learn.product.steps.ads')
        },
        {
          id: 'product_sales_page',
          description: t(
            'campaign.list.empty_state.learn.product.steps.sales_page'
          )
        }
      ]
    };
  }

  render() {
    const { t } = this.props;

    return (
      <div className="empty_state">
        <img
          data-test="empty-state-image"
          className="empty_state__image"
          src={emptyStateImage}
          alt=""
        />
        <h2 data-test="title" className="empty_state__title">
          {t('campaign.list.empty_state.title')}
        </h2>
        <Html data-test="description" className="empty_state__description">
          {t('campaign.list.empty_state.description')}
        </Html>
        <div className="empty_state__cards">
          <ListCard
            key="plus-access-card"
            data-test="plus-access-card"
            className="empty_state__plus_card"
            {...this.plusAccessCard}
          />
          <ListCard
            key="product-card"
            data-test="product-card"
            className="empty_state__product_card"
            {...this.productCard}
          />
        </div>
      </div>
    );
  }
}

export default EmptyState;
